import React, { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import TransportManagement from "../transport-management";
import AddIcon from "@mui/icons-material/Add";
import { tmsService } from "../../utils/services/tmsService";

const TMSList = ({
  isOpened,
  onEditTms,
  clientId,
  disabled,
  onClickAddTms,
  onViewTmsData,
  handleDeleteClick,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const onUpdateTms = async (config) => {
    setData((prev) =>
      prev.map((item) =>
        item._id === config._id ? { ...item, active: config.active } : item
      )
    );
  };

  const fetchProviderDetails = async (id, signal) => {
    if (id) {
      setLoading(true);
      try {
        const tmsResponse = await tmsService.fetch(id, "", "", { signal });

        setData(tmsResponse.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Fetch failed:", error);
      }
    }
  };
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (isOpened) {
      fetchProviderDetails(clientId, signal);
    }
    return () => {
      controller.abort();
    };
  }, [isOpened]);

  return (
    <div>
      <TransportManagement
        addButton={
          <Button
            disabled={disabled}
            onClick={onClickAddTms}
            style={{
              // backgroundColor: disabled ? "#F0F0F0" : "#28A745",
              padding: 0,
              marginRight: 8,
              // paddingRight: 10,
              minHeight: 30,
              // marginTop: 1,
              // marginBottom: 1,
              border: disabled ? "1px solid #BDBDBD" : "1px solid #007613",
            }}
            aria-label="oms"
            variant="outlined"
            startIcon={
              <AddIcon sx={{ color: disabled ? "#BDBDBD" : "#007613" }} />
            }
          >
            <Typography
              fontSize="13px"
              color={disabled ? "#BDBDBD" : "#007613"}
              fontWeight={500}
              fontFamily={"poppins"}
            >
              TMS
            </Typography>
          </Button>
        }
        handleDeleteClick={handleDeleteClick}
        onViewTmsData={onViewTmsData}
        onEditTms={onEditTms}
        onEditData={onEditTms}
        data={data}
        clientId={clientId}
        onUpdateTms={onUpdateTms}
      />
    </div>
  );
};

export default TMSList;
